import { useMutation } from "@apollo/client";
import { useLocation } from "react-router";

import {
  AnalyticsEventCreateDocument,
  AnalyticsEventCreateMutation,
  AnalyticsEventCreateMutationVariables,
  ClientTopicOfInterestEnum
} from "@typing/Generated";
import { generateHTMLId } from "@utils/htmlUtils";
import storage from "@utils/storageUtils";

type Props = {
  action: "click" | "visit";
  topic: ClientTopicOfInterestEnum;
};

const useCreateActivationAnalyticsEvent = ({ action, topic }: Props) => {
  const location = useLocation();

  const [createAnalyticsEvent] = useMutation<AnalyticsEventCreateMutation, AnalyticsEventCreateMutationVariables>(
    AnalyticsEventCreateDocument
  );

  const createAnalyticsEventWithTopic = () => {
    storage.get("activationAttemptId").then(activationAttemptId => {
      if (!activationAttemptId) {
        activationAttemptId = generateHTMLId();
        storage.set("activationAttemptId", activationAttemptId);
      }
      createAnalyticsEvent({
        variables: {
          eventData: {
            action,
            activationAttemptId,
            page: location.pathname,
            topic,
            type: "activate"
          }
        }
      });
    });
  };

  return createAnalyticsEventWithTopic;
};

export default useCreateActivationAnalyticsEvent;
